export * from './2_zyjydjwdzx.component';
export * from './area';
